export class VocabularyBookInUseError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, VocabularyBookInUseError.prototype);
  }
}
